import styled from 'styled-components';

const CourseYear = styled.span`
  color: #999;
`;

export default CourseYear;